import { CheckboxItem, MenuTop, Output, Text } from '@components';
import { BodyPartChildOptionValueEnum, styleConstant } from '@constant';
import { useOutput } from '@hooks';
import { colorSet } from '@theme';
import { useEffect, useState } from 'react';
import { useBodyPartActions } from '@remote-hooks';
import {
  BodyArmIcon,
  BodyEyeIcon,
  BodyFootIcon,
  BodyHandIcon,
  BodyLegIcon,
  BodyLipsIcon
} from '@assets/iconComponents';

const BodyPartOutputPage = () => {
  const { storedBodyPartChildOptionValue, onSetBodyPart } = useOutput();

  // 마운트 상태를 추적하는 state
  const [isComponentMounted, setIsComponentMounted] = useState(false);

  const { onInitBodyPart } = useBodyPartActions();

  useEffect(() => {
    setIsComponentMounted(true);
    if (!isComponentMounted) return;

    return () => {
      onInitBodyPart();
    };
  }, [isComponentMounted, onInitBodyPart]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <MenuTop />

      {/* 옵션 */}
      <div
        style={{
          height: styleConstant.topPageNameHeight,
          padding: '40px',
          borderBottom: `1px solid ${colorSet.gray300}`
        }}
      >
        <Text variant="h2" fontWeight="bold">
          신체 부위
        </Text>
      </div>

      <div style={{ display: 'flex' }}>
        {/* 좌측 메뉴 */}
        <div
          style={{
            width: styleConstant.outputPageLeftMenuWidth,
            padding: '24px 32px',
            backgroundColor: colorSet.gray100,
            boxSizing: 'border-box',
            position: 'sticky',
            top: styleConstant.menuTopHeight,
            minHeight: `calc(100vh - ${styleConstant.menuTopHeight + styleConstant.topPageNameHeight}px)`,
            maxHeight: `calc(100vh - ${styleConstant.menuTopHeight}px)`,
            borderRight: `1px solid ${colorSet.gray300}`
          }}
        >
          <Text variant="body1" fontWeight="bold">
            하위 스페셜 단추
          </Text>
          <div style={{ width: 224, padding: '8px 24px 8px 0px', marginTop: '8px' }}>
            <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '24px 0px' }}>
              <CheckboxItem
                label="손"
                imageComponent={<BodyHandIcon style={{ width: 48, height: 48 }} />}
                imageAlign="column"
                isChecked={storedBodyPartChildOptionValue[BodyPartChildOptionValueEnum.손]}
                onChange={() => {
                  onSetBodyPart({
                    [BodyPartChildOptionValueEnum.손]: !storedBodyPartChildOptionValue[BodyPartChildOptionValueEnum.손]
                  });
                }}
              />
              <CheckboxItem
                label="발"
                imageComponent={<BodyFootIcon style={{ width: 48, height: 48 }} />}
                imageAlign="column"
                isChecked={storedBodyPartChildOptionValue[BodyPartChildOptionValueEnum.발]}
                onChange={() => {
                  onSetBodyPart({
                    [BodyPartChildOptionValueEnum.발]: !storedBodyPartChildOptionValue[BodyPartChildOptionValueEnum.발]
                  });
                }}
              />
              <CheckboxItem
                label="팔"
                imageComponent={<BodyArmIcon style={{ width: 48, height: 48 }} />}
                imageAlign="column"
                isChecked={storedBodyPartChildOptionValue[BodyPartChildOptionValueEnum.팔]}
                onChange={() => {
                  onSetBodyPart({
                    [BodyPartChildOptionValueEnum.팔]: !storedBodyPartChildOptionValue[BodyPartChildOptionValueEnum.팔]
                  });
                }}
              />
              <CheckboxItem
                label="다리"
                imageComponent={<BodyLegIcon style={{ width: 48, height: 48 }} />}
                imageAlign="column"
                isChecked={storedBodyPartChildOptionValue[BodyPartChildOptionValueEnum.다리]}
                onChange={() => {
                  onSetBodyPart({
                    [BodyPartChildOptionValueEnum.다리]:
                      !storedBodyPartChildOptionValue[BodyPartChildOptionValueEnum.다리]
                  });
                }}
              />
              <CheckboxItem
                label="입"
                imageComponent={<BodyLipsIcon style={{ width: 48, height: 48 }} />}
                imageAlign="column"
                isChecked={storedBodyPartChildOptionValue[BodyPartChildOptionValueEnum.입]}
                onChange={() => {
                  onSetBodyPart({
                    [BodyPartChildOptionValueEnum.입]: !storedBodyPartChildOptionValue[BodyPartChildOptionValueEnum.입]
                  });
                }}
              />
              <CheckboxItem
                label="눈"
                imageComponent={<BodyEyeIcon style={{ width: 48, height: 48 }} />}
                imageAlign="column"
                isChecked={storedBodyPartChildOptionValue[BodyPartChildOptionValueEnum.눈]}
                onChange={() => {
                  onSetBodyPart({
                    [BodyPartChildOptionValueEnum.눈]: !storedBodyPartChildOptionValue[BodyPartChildOptionValueEnum.눈]
                  });
                }}
              />
            </div>
          </div>
        </div>

        {/* 검색 결과 */}
        <Output />
      </div>
    </div>
  );
};

export default BodyPartOutputPage;
